// extracted by css-extract-rspack-plugin
export default {"header":"header-osLp3B","title":"title-OT6EHd","back":"back-aA5kI2"};